import { v4 as uuidv4 } from "uuid"
import { CheckCircle, Target, Code, Monitor, Cloud, Underline, Link } from 'react-feather'

export const ModuleData = () => {
  return {
    type: 'CHECKBOX',
    id: uuidv4(),
    text: "",
    tempText: "",
    isCompleted: false,
    fontColor: 'black',
    highlightColor: '',
    tags: [],
    prevTags: [],
    // comments: [
    //   {
    //     id: uuidv4(),
    //     text: "",
    //     commentedBy: 'system',
    //     time: ""
    //   }
    // ],
    comments: [],
    children: []
  }
}

export const TaskData = () => {
  return {
    id: uuidv4(),
    text: "",
    tempText: "",
    isCompleted: false,
    type: 'CHECKBOX',
    fontColor: 'black',
    highlightColor: '',
    tags: [],
    prevTags: [],
    // comments: [
    //   {
    //     id: uuidv4(),
    //     text: "",
    //     commentedBy: 'system',
    //     time: ""
    //   }
    // ],
    comments: []
  }
}

export const SelectTypeOption = () => {
  return [
    { key: "CHECKBOX", name: "Checkbox", icon: () => <CheckCircle /> },
    { key: "BULLET", name: "Bullet", icon: () => <Target /> },
    { key: "PARAGRAPH", name: "Paragraph", icon: () => <Code /> }
  ]
}

export const SelectMailOption = () => {
  return [
    { key: "ADD", name: "Add" },
    { key: "PARAGRAPH1", name: "Paragraph", icon: () => <Code /> }
  ]
}

export const SelectAttachDocument = () => {
  return [
    { key: "LOCAL", name: "Local", icon: () => <Monitor /> },
    { key: "DMS", name: "DMS", icon: () => <Cloud /> },
    { key: "Hyperlink", name: "Hyperlink", icon: () => <Link /> }
  ]
}

export const TaskTagOptions = () => {
  return [
    { key: "1", label: "Personal", color: "#029d5b" },
    { key: "2", label: "Important", color: "#d57c2a" },
    { key: "3", label: "Company", color: "#523cd7" },
    { key: "4", label: "Private", color: "#db3937" }
  ]
}